import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=05982316&scoped=true"
import script from "./organization.vue?vue&type=script&lang=js"
export * from "./organization.vue?vue&type=script&lang=js"
import style0 from "./organization.vue?vue&type=style&index=0&id=05982316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05982316",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ToastAlert: require('/var/www/git/queue/front/components/ToastAlert.vue').default})
